const showRule = (rules: any, ctx: any) => {
  const ruleValue = rules?.ruleValue;
  const ruleVariable = rules?.ruleVariable;
  const match = rules?.match === undefined ? true : rules?.match;

  if (match) {
    if (ctx?.core?.data[ruleVariable]?.value === ruleValue) return true;
    else return false;
  } else {
    if (ctx?.core?.data[ruleVariable]?.value === ruleValue) return false;
    else return true;
  }
};

const evaluateUIRules = (additionalData: any, ctx: any) => {
  const ruleType = additionalData?.ruleType;
  if (ruleType === undefined) {
    return showRule(additionalData, ctx);
  } else if (ruleType === "AND") {
    const rules = additionalData?.rules;
    let show = true;

    rules?.forEach((rule: any) => {
      show = show && showRule(rule, ctx);
    });
    return show;
  } else if (ruleType === "OR") {
    const rules = additionalData?.rules;
    let show = false;

    rules?.forEach((rule: any) => {
      show = show || showRule(rule, ctx);
    });
    return show;
  }
};

export default evaluateUIRules;
